import { render, staticRenderFns } from "./BasicFreqEdit.vue?vue&type=template&id=43de68ff"
import script from "./BasicFreqEdit.vue?vue&type=script&lang=js"
export * from "./BasicFreqEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports